module.exports = __webpack_public_path__ + "img/5122c7e.jpg";